module.exports = __webpack_public_path__ + "assets/img/9.7c4f64ac.png";